import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Please sign in.");
      nav("/admin/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5">
        <div>
          <h2 className="font-heading text-4xl font-semibold">New password</h2>
          <p className="text-muted-foreground text-sm mt-1">Choose a strong new password.</p>
        </div>
        {error && <div className="rounded-lg bg-destructive/10 text-destructive text-sm p-3">{error}</div>}
        <div>
          <Label>New Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" required minLength={6} />
        </div>
        <Button type="submit" disabled={loading || !token} className="w-full rounded-full h-11" data-testid="reset-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
        </Button>
        <Link to="/admin/login" className="block text-center text-sm text-muted-foreground hover:text-primary">Back to sign in</Link>
      </form>
    </div>
  );
}
